import { UnreachableCaseError } from "@opensea/utils"
import type { Dispatch, SetStateAction } from "react"
import { Paginator } from "@/lib/pagination/paginator"
import type { Activities, Activity } from "./activity-subscription"

type ActivitySortBy = "eventTime"

class ActivityPaginator extends Paginator<Activities[number], ActivitySortBy> {
  protected getValues(item: Activity, sortBy: ActivitySortBy | undefined) {
    switch (sortBy) {
      case "eventTime":
      case undefined:
        return [new Date(item.eventTime), item.id]
      default:
        throw new UnreachableCaseError(sortBy)
    }
  }
}

const activityPaginator = new ActivityPaginator()

export function insertActivity(
  msg: Activity,
  setItems: Dispatch<SetStateAction<Activities>>,
  insertIntoLastPlace = true,
) {
  setItems(prevItems =>
    activityPaginator.insertInOrder(
      msg,
      prevItems,
      { by: "eventTime", direction: "DESC" },
      { insertIntoLastPlace },
    ),
  )
}
